import { Link } from '@/components/LocalizedLink';
import { useLanguage } from '@/contexts/LanguageContext';
import type { ServiceDefinition } from '@/lib/serviceCatalog';
import { localizeServiceText } from '@/lib/serviceCatalog';

type RelatedServicesBlockProps = {
  services: ServiceDefinition[];
  title?: string;
};

const RelatedServicesBlock = ({ services, title }: RelatedServicesBlockProps) => {
  const { lang } = useLanguage();

  if (!services.length) return null;

  return (
    <section className="mt-16 border-t border-border pt-12">
      <h2 className="font-display text-3xl font-bold text-foreground mb-6">
        {title || (lang === 'tr' ? 'İlgili Hizmetler' : 'Related Services')}
      </h2>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {services.map((service) => (
          <Link
            key={service.slug}
            to={`/services/${service.slug}`}
            className="rounded-xl border border-border/70 p-5 bg-card/40 hover:bg-card transition-colors"
          >
            <p className="font-body text-xs tracking-[0.2em] uppercase text-muted-foreground mb-2">
              {localizeServiceText(service.shortLabel, lang)}
            </p>
            <h3 className="font-display text-xl text-foreground mb-2">
              {localizeServiceText(service.navTitle, lang)}
            </h3>
            <p className="font-body text-sm text-muted-foreground leading-relaxed">
              {localizeServiceText(service.intro, lang)}
            </p>
          </Link>
        ))}
      </div>
    </section>
  );
};

export default RelatedServicesBlock;
